<template>
  <div class="about" :style="`color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}`">
    <el-row style="text-align: justify; margin-top: 30px;">
      <el-col :xl="{span: 14, offset: 5}" :lg="{span: 15, offset: 5}" :md="{span: 18, offset: 3}"
        :sm="{span: 20, offset: 2}" :xs="{span: 22, offset: 1}">
        <h3>About GEAR-19</h3>
        <p>
          GEAR-19 is a resource to track the genomic evolution of SARS-CoV-2, the virus which is responsible for the
          current worldwide pandemic of COVID-19. Sequencing of viral genomes can provide insights of the spread,
          changes in the sequence over time and demographic associations. This information is useful in viral
          surveillance and can be used to monitor the spread across states in India. As sequenced viral genomes are
          rapidly deposited on public repositories like GISAID, it is the need of the hour for even quicker analysis and
          interpretations. We hope to make this an exhaustive resource for COVID-19 genomic data analysis powered by our
          in-house as well as publicly deposited data from India.
        </p>
      </el-col>
    </el-row>

    <!-- Team Section from here -->
    <el-row>
      <el-col :xl="{span: 14, offset: 5}" :lg="{span: 15, offset: 5}" :md="{span: 18, offset: 3}"
        :sm="{span: 20, offset: 2}" :xs="{span: 22, offset: 1}">
        <h3>Team</h3>
        <div class="avatar-container">
          <div class="team-member">
            <el-avatar shape="circle" src="./images/team_akshay.jpeg" :size="200">
            </el-avatar>
            <div class="team-member-name">
              Akshay Avvaru
            </div>
            <div class="team-member-icons">
              <span><a href="https://twitter.com/avvaruakshay" :style="`color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}`"><i class="fab icon-fa-twitter"></i></a></span>
              <span><a href="https://github.com/avvaruakshay" :style="`color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}`"><i class="fab icon-fa-github"></i></a></span>
            </div>
            <div class="team-member-role">
              <h4>Website design</h4>
            </div>
          </div>

          <div class="team-member">
            <el-avatar shape="circle" src="./images/team_reuben.jpeg" :size="200">
            </el-avatar>
            <div class="team-member-name">
              Reuben Jacob Mathew
            </div>
            <div class="team-member-icons">
              <span><a href="https://twitter.com/rjmat97" :style="`color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}`"><i class="fab icon-fa-twitter"></i></a></span>
              <span><a href="https://github.com/rjmat97" :style="`color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}`"><i class="fab icon-fa-github"></i></a></span>
            </div>
            <div class="team-member-role">
              <h4>Website design</h4>
            </div>
          </div>

          <div class="team-member">
            <el-avatar shape="circle" src="./images/team_sofia.jpeg" :size="200">
            </el-avatar>
            <div class="team-member-name">
              Sofia Banu
            </div>
            <div class="team-member-icons">
              <span><a href="https://twitter.com/It_is_moi_sofia" :style="`color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}`"><i class="fab icon-fa-twitter"></i></a></span>
            </div>
            <div class="team-member-role">
              <h4>Content and data curation</h4>
            </div>
          </div>

          <div class="team-member">
            <el-avatar shape="circle" src="./images/team_priya.jpeg" :size="200">
            </el-avatar>
            <div class="team-member-name">
              Priya Singh
            </div>
            <div class="team-member-icons">
              <span><a href="https://twitter.com/priya120195" :style="`color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}`"><i class="fab icon-fa-twitter"></i></a></span>
            </div>
            <div class="team-member-role">
              <h4>Content and data curation</h4>
            </div>
          </div>

          <div class="team-member">
            <el-avatar shape="circle" src="./images/team_sreelekshmi.jpg" :size="200">
            </el-avatar>
            <div class="team-member-name">
              Sreelekshmi MS
            </div>
            <div class="team-member-icons">
              <span><a href="https://twitter.com/sreelekshmi_ms" :style="`color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}`"><i class="fab icon-fa-twitter"></i></a></span>
            </div>
            <div class="team-member-role">
              <h4>Content and data curation</h4>
            </div>
          </div>

          <div class="team-member">
            <el-avatar shape="circle" src="./images/team_deep.jpeg" :size="200">
            </el-avatar>
            <div class="team-member-name">
              Divya Deep Sowpati
            </div>
            <div class="team-member-icons">
              <span><a href="https://twitter.com/TropeDragons" :style="`color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}`"><i class="fab icon-fa-twitter"></i></a></span>
              <span><a href="https://www.instagram.com/deepdoesdesign/" :style="`color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}`"><i class="fab icon-fa-instagram"></i></a></span>
            </div>
            <div class="team-member-role">
              <h4>Logo design</h4>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col :xl="{span: 14, offset: 5}" :lg="{span: 15, offset: 5}" :md="{span: 18, offset: 3}"
        :sm="{span: 20, offset: 2}" :xs="{span: 22, offset: 1}">
        <h3>Contact</h3>
        <div>
          In case of any queries, suggestions, or feedback, please contact <a href="mailto:tej@ccmb.res.in"  class="click-link">tej@ccmb.res.in</a>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { store } from '@/scripts/store.js'

export default {
  name: 'About',
  data() {
    return { 
      store
    }
  },
}
</script>

<style scoped>
div.avatar-container {
  text-align: center;
  margin: 20px;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-evenly;
}

div.team-member {
  margin-top: 20px;
}

div.team-member-icons span {
  margin: 5px;
}

div.team-member-icons a {
  color: black;
}

h3, h4 {
  margin-top: 15px;
  margin-bottom: 5px;
  font-family: 'Oxygen', Arial, Helvetica, sans-serif;
}

.click-link {
  text-decoration: none;
  padding: 3px 5px;
  border-radius: 3px;
  background-color: rgba(150, 155, 155, 0.6);
  font-size: 0.8em; 
  font-weight: bold;
}
</style>